import { Grid as MuiGrid, GridProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { GridProps };

export const Grid: React.ComponentType<GridProps> = styled(MuiGrid)<GridProps>(() => ({}));
